import { motion, useReducedMotion } from "framer-motion";
import { Chapter, EASE, MaskedLines, Reveal } from "@/components/aklive/motion";

const STEPS = ["Idea", "Identity", "Website", "Campaign", "Business"];

export const Pivot = () => {
  const reduce = useReducedMotion();
  return (
    <section className="py-24 md:py-40" data-testid="pivot-section">
      <div className="container-ak">
        <Chapter index="02" label="The Pivot" />
        <div className="grid gap-16 lg:grid-cols-12 lg:gap-8">
          <div className="lg:col-span-7">
            <h2 className="font-display text-4xl font-bold leading-[1.05] tracking-tight text-ink sm:text-5xl lg:text-6xl">
              <MaskedLines
                lines={[
                  "We started with design.",
                  <span key="l2">
                    We evolved around <span className="text-ember">business.</span>
                  </span>,
                ]}
              />
            </h2>
            <Reveal delay={0.2} className="mt-8 md:mt-12">
              <p className="max-w-[560px] text-base leading-relaxed text-ink2 md:text-lg">
                We stopped asking only what needs to be designed and started asking what the design needs to achieve.
              </p>
            </Reveal>
          </div>

          <div className="relative lg:col-span-4 lg:col-start-9">
            <motion.span
              aria-hidden="true"
              initial={reduce ? { opacity: 1 } : { scaleY: 0 }}
              whileInView={{ scaleY: 1 }}
              viewport={{ once: true, margin: "-10% 0px" }}
              transition={{ duration: 1.1, ease: EASE }}
              className="absolute left-0 top-0 h-full w-px origin-top bg-line"
            />
            <ol className="pl-8">
              {STEPS.map((step, i) => {
                const last = i === STEPS.length - 1;
                return (
                  <Reveal key={step} delay={0.15 + i * 0.12}>
                    <li className={`flex items-baseline gap-5 py-4 md:py-5 ${last ? "" : "border-b border-line"}`}>
                      <span className="font-mono text-[10px] tracking-[0.2em] text-ink2">0{i + 1}</span>
                      <span
                        className={`font-display text-2xl font-bold tracking-tight md:text-3xl ${
                          last ? "text-ember" : "text-ink"
                        }`}
                      >
                        {step}
                      </span>
                      {!last && (
                        <span aria-hidden="true" className="ml-auto text-ink2">
                          ↓
                        </span>
                      )}
                    </li>
                  </Reveal>
                );
              })}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
};
